module.exports = {"content":{"paragraph":{"text":""},"close":{"text":"close"}},"config":{"id":"notificationSection","theme":"theme-background-color-light","customClass":"notification-sample"}}


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/notification/resources/content.json
// module id = 926
// module chunks = 4